export default "<div class=\"filter-block\">\n\t<button>Sort & Filter\n\t\t<img src=\"assets/img/filter.png\">\n\t</button>\n</div>"